export default __webpack_public_path__ + "static/media/2.987e0c3a.webp";